import { memo as Memo } from 'react'

//* HOC's
import { withDataContext } from 'context'

//* Components
import CustomLink from 'components/common/CustomLink'
import Icon from 'components/common/Icon'

//* Helpers
import config from 'helpers/_config'

//* Styles
import BottomTabNavigationStyle from './style'

const BottomTabNavigation = Memo(({ menuIsOpen, openMenu, hasBookmark }) => {

    return (
        <BottomTabNavigationStyle>
            <CustomLink url={config.routes.map.path}>
                <Icon className="h5" name="map" />
            </CustomLink>

            <CustomLink url={config.routes.search.path}>
                <Icon className="h5" name="search" />
            </CustomLink>

            <div className={`middle-icon`}>
                <span className={`burger-icon ${menuIsOpen ? 'active' : ''}`} onClick={openMenu} />
            </div>

            <CustomLink url={config.routes.bookmarks.path}>
                <Icon className={`h5 ${hasBookmark ? 'active' : ''}`} name="bookmarks" />
            </CustomLink>

            <CustomLink url={config.routes.events.path}>
                <Icon className="h5" name="calendar" />
            </CustomLink>
        </BottomTabNavigationStyle>
    )
})

export default withDataContext(BottomTabNavigation, ['hasBookmark'])